import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/assign';
import * as selectors from 'selectors/assign';
import { Button } from 'ui';

class NextStepButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.goToNextStep = this.goToNextStep.bind(this);
    this.goToPreviousStep = this.goToPreviousStep.bind(this);
    this.setLoading = this.setLoading.bind(this);
  }

  goToNextStep() {
    const {
      isReviewing,
      submitAssignment,
      toggleContainer,
      setActiveStep,
      nextStep,
      assignErrorMessage,
    } = this.props;

    if (isReviewing) {
      this.setLoading(true);
      submitAssignment()
        .then(() => {
          this.setLoading(false);
          toggleContainer();
        })
        .catch(() => {
          this.setLoading(false);
          // eslint-disable-next-line no-alert
          alert(assignErrorMessage);
        });
    } else {
      setActiveStep(nextStep);
    }
  }

  goToPreviousStep() {
    this.props.setActiveStep(this.props.previousStep);
  }

  setLoading(loading) {
    this.setState({ loading });
  }

  render() {
    const LABELS = {
      CONTENT: 'Select Content',
      ASSIGNEES: 'Select Assignees',
      SCHEDULING: 'Schedule Assignment',
      REVIEW: 'Review and Assign',
      SUBMIT: 'Send Assignment',
    };
    const { previousStep, isCompleted, nextStep } = this.props;
    const { loading } = this.state;

    return (
      <div className="AssignStep AssignStep--submit">
        {previousStep && (
          <button
            type="button"
            className="AssignModal-backBtn u-showBelowXS"
            onClick={this.goToPreviousStep}
          >
            Back
          </button>
        )}
        <Button
          className={`AssignModal-nextBtn ${
            !isCompleted ? '' : 'AssignModal-nextBtnEnabled'
          }`}
          disabled={!isCompleted}
          loading={loading}
          onClick={this.goToNextStep}
          customColor
          tall
        >
          {LABELS[nextStep]}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isReviewing: selectors.isReviewing(state),
  isCompleted: selectors.isActiveStepCompleted(state),
  nextStep: selectors.getNextStep(state),
  previousStep: selectors.getPreviousStep(state),
  assignErrorMessage: state.meta.i18n.assign_error_message,
});

const mapDispatchToProps = {
  setActiveStep: actions.setActiveStep,
  submitAssignment: actions.submitAssignment,
};

export default connect(mapStateToProps, mapDispatchToProps)(NextStepButton);
